module.exports = __webpack_public_path__ + "img/word.c65f617e.svg";